import { createFileRoute, Link } from "@tanstack/react-router";
import { ProjectForm } from "@/components/admin/ProjectForm";

export const Route = createFileRoute("/admin/projects/new")({
  component: NewProject,
});

function NewProject() {
  return (
    <div>
      <Link to="/admin/projects" className="text-sm text-muted-foreground hover:text-foreground">
        ← Back to projects
      </Link>
      <h1 className="mt-3 font-display text-3xl font-semibold tracking-tight text-foreground">
        New project
      </h1>
      <div className="mt-8">
        <ProjectForm />
      </div>
    </div>
  );
}
